// BURGER MENU

let blogMenu = document.getElementById('burger-menu');
let blogMenuMobile = document.getElementById('menu-mobile');
let blogMainHeader = document.getElementById('blog-header');

// LAZY LOADING
var lazyLoadInstance = new LazyLoad({});
lazyLoadInstance.update()


if(blogMenu)
blogMenu.addEventListener('click', ()=> {
    //bodyModal.classList.toggle('noScroll')
    blogMenu.classList.toggle('active');
    blogMenuMobile.classList.toggle('active');
    blogMainHeader.classList.toggle('mobile-active');
})



